// Shared "share this" behavior: native share sheet where available,
// clipboard-copy fallback otherwise. Used by the article details page and
// the category list's per-article share buttons.
export async function shareContent({ title, text, url, imageUrl }) {
  const shareData = {
    title,
    text,
    url,
  };

  // Try sharing image + content
  if (navigator.share && navigator.canShare) {
    if (imageUrl) {
      try {
        const response = await fetch(imageUrl);
        if (response.ok) {
          const blob = await response.blob();
          const extension = blob.type === "image/png" ? "png" : blob.type === "image/webp" ? "webp" : "jpg";
          const file = new File([blob], `article-image.${extension}`, { type: blob.type || "image/jpeg" });

          if (navigator.canShare({ files: [file] })) {
            await navigator.share({ ...shareData, files: [file] });
            return { shared: true, copied: false };
          }
        }
      } catch (err) {
        console.error("Image attach failed, falling back to link share:", err);
        // fall through to text+url share below
      }
    }

    try {
      await navigator.share(shareData);
      return { shared: true, copied: false };
    } catch (err) {
      if (err.name === "AbortError") return { shared: false, copied: false };
      console.error("Share failed:", err);
    }
  }

  // Fallback: copy URL
  if (navigator.clipboard) {
    try {
      await navigator.clipboard.writeText(url);

      return {
        shared: false,
        copied: true,
      };
    } catch (err) {
      console.error("Clipboard copy failed:", err);
    }
  }

  return {
    shared: false,
    copied: false,
  };
}
